// @ts-nocheck
document.addEventListener("alpine:init", () => {
    Alpine.data("productInfo", (sectionId) => ({
      sectionId,
      mainProduct: {},
      variantIdChangedUnsubscriber: undefined,

      // Sticky ATC state
      stickyAtcEnabled: false,
      stickyAtcVisible: false,
      stickyAtcLoading: false,
      stickyAtcDisabled: false,
      stickyAtcObserver: null,
      stickyAtcFooterObserver: null,
      stickyAtcFooterVisible: false,
      stickyAtcTargetSelector: '[data-sticky-atc-target]',
      stickyAtcVariantId: null,
      stickyAtcPrice: 0,
      stickyAtcCompareAtPrice: null,
      stickyAtcSellingPlanId: null,
  
      /**
       * Initialize the product card component
       */
      init() {
        this.parseProductJson();
  
        if (!this.mainProduct) {
          console.error("mainProduct is missing");
          return;
        }
  
        this.addEventListeners();

        // Initialize sticky ATC if enabled
        if (this.stickyAtcEnabled) {
          this.$nextTick(() => {
            this.setupStickyAtcObserver();
            this.setupStickyAtcEventListeners();
          });
        }
      },

      addEventListeners() {},
  
      /**
       * Initialize the new product
       * @param {Object} product - The new product
       */
      initNewProduct(product) {
        this.mainProduct = product;
  
        this.init();
      },
  
      /**
       * Parse the product JSON
       */
      parseProductJson() {
        const productData = JSON.parse(this.$refs.productDataJson.textContent);
  
        this.mainProduct = productData;
      },
  
      /**
       * Load the product
       * @param {string} productHandle - The product handle
       * @param {string} preselectedVariantId - The preselected variant ID
       */
      loadProduct(productHandle, preselectedVariantId = "") {
        const additionalSectionIds = this.getAdditionalSectionIds();
        const allSectionIds = [this.sectionId, ...additionalSectionIds].join(',');

        const url = `/products/${productHandle}?${
          preselectedVariantId ? `variant=${preselectedVariantId}` : ""
        }&sections=${allSectionIds}`;
        const productUrl = `/products/${productHandle}.js`;

        window.dispatchEvent(new CustomEvent('spinner:start'));
        fetch(url)
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.json();
          })
          .then((response) => {
            if (!response[this.sectionId]) {
              console.error("Product section not found");
              return;
            }

            morphSection(this.sectionId, response[this.sectionId]);

            for (const sectionId of additionalSectionIds) {
              if (response[sectionId]) {
                morphSection(sectionId, response[sectionId]);
              }
            }

            window.history.pushState(
              { urlPath: productHandle },
              "",
              productHandle
            );

            window.dispatchEvent(new CustomEvent('spinner:stop'));
          })
          .catch((error) => {
            console.error("Error loading product:", error);
            window.dispatchEvent(new CustomEvent('spinner:stop'));
          });
      },

      /**
       * Collects normalized section IDs from elements with data-update-with-render-api.
       * @returns {string[]} Array of section IDs to update.
       */
      getAdditionalSectionIds() {
        const ids = [];
        document.querySelectorAll('[data-update-with-render-api]').forEach((el) => {
          const wrapper = el.closest('.shopify-section');
          if (!wrapper?.id) return;
          const normalizedId = wrapper.id.replace(/^shopify-section-/, '');
          if (normalizedId !== this.sectionId && !ids.includes(normalizedId)) {
            ids.push(normalizedId);
          }
        });
        return ids;
      },
  
      reExecuteScript() {
        const scripts = document.querySelectorAll(".re-execute-scripts");
        scripts.forEach((script) => {
          // console.log(script);  // Log the script content
          const newScript = document.createElement("script");
          const src = newScript.getAttribute("src")
            ? newScript.getAttribute("src")
            : "";
          if (src != "") {
            newScript.setAttribute("src", src);
          } else {
            newScript.text = script.text;
          }
          // Append the script to the container
          this.$refs.productInfoElement.appendChild(newScript);
          // Remove the script immediately after execution
        });
      },

      // =====================
      // Sticky ATC Methods
      // =====================

      /**
       * Initialize sticky ATC with settings
       * @param {Object} options - Configuration options
       */
      initStickyAtc(options = {}) {
        this.stickyAtcEnabled = options.enabled ?? true;
        this.stickyAtcTargetSelector = options.targetSelector || '[data-sticky-atc-target]';
        this.stickyAtcVariantId = options.variantId || null;
        this.stickyAtcPrice = options.price || 0;
        this.stickyAtcCompareAtPrice = options.compareAtPrice || null;
        this.stickyAtcFormId = options.formId || null;

        if (this.stickyAtcEnabled) {
          this.$nextTick(() => {
            this.setupStickyAtcObserver();
            this.setupStickyAtcEventListeners();
          });
        }
      },

      /**
       * Setup IntersectionObserver for sticky ATC visibility
       */
      setupStickyAtcObserver() {
        this.destroyStickyAtcObserver();
        const targetElement = document.querySelector(this.stickyAtcTargetSelector);

        if (!targetElement) {
          console.warn('[Sticky ATC] Target element not found:', this.stickyAtcTargetSelector);
          return;
        }

        const observerOptions = {
          root: null,
          rootMargin: '0px',
          threshold: 0
        };

        let targetScrolledPast = false;

        this.stickyAtcObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const isAboveViewport = entry.boundingClientRect.bottom < 0;
            targetScrolledPast = !entry.isIntersecting && isAboveViewport;
            this.stickyAtcVisible = targetScrolledPast && !this.stickyAtcFooterVisible;
          });
        }, observerOptions);

        this.stickyAtcObserver.observe(targetElement);

        // Observe footer to hide sticky ATC when footer is visible
        const footerElement = document.querySelector('.shopify-section-group-footer-group');
        if (footerElement) {
          this.stickyAtcFooterObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              this.stickyAtcFooterVisible = entry.isIntersecting;
              this.stickyAtcVisible = targetScrolledPast && !this.stickyAtcFooterVisible;
            });
          }, observerOptions);

          this.stickyAtcFooterObserver.observe(footerElement);
        }
      },

      /**
       * Setup event listeners for variant and selling plan changes
       */
      setupStickyAtcEventListeners() {
        const section = document.querySelector(`#shopify-section-${this.sectionId}`);
        
        if (section) {
          section.addEventListener('variant:update', this.handleStickyAtcVariantUpdate.bind(this));
          section.addEventListener('variant:selected', this.handleStickyAtcVariantSelected.bind(this));
        }

        // Global listener as fallback
        document.addEventListener('variant:update', this.handleStickyAtcVariantUpdate.bind(this));
        window.addEventListener('popstate', this.handleStickyAtcUrlChange.bind(this));
      },

      /**
       * Handle variant update event
       */
      handleStickyAtcVariantUpdate(event) {
        const variant = event.detail?.resource;

        if (variant) {
          this.stickyAtcVariantId = variant.id;
          this.stickyAtcPrice = variant.price;
          this.stickyAtcCompareAtPrice = variant.compare_at_price;
          this.stickyAtcDisabled = !variant.available;
        }
      },

      /**
       * Handle variant selected event (temporarily disable)
       */
      handleStickyAtcVariantSelected() {
        this.stickyAtcDisabled = true;
      },

      /**
       * Handle URL change for variant
       */
      handleStickyAtcUrlChange() {
        const urlParams = new URLSearchParams(window.location.search);
        const variantId = urlParams.get('variant');
        if (variantId) {
          this.stickyAtcVariantId = parseInt(variantId, 10);
        }
      },

      /**
       * Format money value
       * @param {number} cents - Amount in cents
       * @returns {string} - Formatted money string
       */
      formatStickyAtcMoney(cents) {
        if (typeof cents !== 'number' || isNaN(cents)) {
          return '';
        }
        
        if (window.Shopify && window.Shopify.formatMoney) {
          return window.Shopify.formatMoney(cents);
        }

        const amount = (cents / 100).toFixed(2);
        const currencySymbol = window.Shopify?.currency?.symbol || '£';
        return `${currencySymbol}${amount}`;
      },

      /**
       * Get formatted current price
       */
      get stickyAtcFormattedPrice() {
        return this.formatStickyAtcMoney(this.stickyAtcPrice);
      },

      /**
       * Get formatted compare-at price (null if no discount)
       */
      get stickyAtcFormattedCompareAtPrice() {
        if (!this.stickyAtcCompareAtPrice) {
          return null;
        }
        return this.formatStickyAtcMoney(this.stickyAtcCompareAtPrice);
      },

      /**
       * Check if product has a discount
       */
      get stickyAtcHasDiscount() {
        return this.stickyAtcCompareAtPrice && this.stickyAtcCompareAtPrice > this.stickyAtcPrice;
      },

      /**
       * Check if variant is available
       */
      get stickyAtcIsAvailable() {
        if (!this.mainProduct || !this.stickyAtcVariantId) return true;
        const variant = this.mainProduct.variants?.find(v => v.id === this.stickyAtcVariantId);
        return variant ? variant.available : true;
      },

      /**
       * Cleanup sticky ATC observer
       */
      destroyStickyAtcObserver() {
        if (this.stickyAtcObserver) {
          this.stickyAtcObserver.disconnect();
          this.stickyAtcObserver = null;
        }
        if (this.stickyAtcFooterObserver) {
          this.stickyAtcFooterObserver.disconnect();
          this.stickyAtcFooterObserver = null;
        }
      },
    }));
  });
  